import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLimit = (state: StoreSchema) => state.products.limit
